import { call, put, takeEvery, all } from 'redux-saga/effects';
import BugReportApi from '../../api/BugReportApi';
import * as Actions from '../actions/bugReportsActions';
import * as Types from '../actions/bugReportsActionTypes';

function* getBugReports() {
  try {
    const response = yield call(BugReportApi.getBugReports);
    console.info(response);
    yield put(Actions.getBugReportsSuccess(response));
  } catch (error) {
    console.info(error);
    yield put(Actions.getBugReportsFailure(error));
  }
}

function* submitBugReport(action) {
  try {
    const response = yield call(BugReportApi.postBugReport, action.data);
    console.info(response);
    yield put(Actions.submitBugReportSuccess(response));
    yield call(action.onSuccess);
  } catch (error) {
    console.info(error);
    yield put(Actions.submitBugReportFailure(error));
    yield call(action.onFail, error);
  }
}

function* updateBugReport(action) {
  try {
    const response = yield call(BugReportApi.updateBugReport, action.data);
    console.info(response);
    yield put(Actions.updateBugReportSuccess(response));
  } catch (error) {
    console.info(error);
    yield put(Actions.updateBugReportFailure(error));
  }
}

export default function* bugReportFlow() {
  yield all([
    takeEvery(Types.GET_BUG_REPORTS, getBugReports),
    takeEvery(Types.SUBMIT_BUG_REPORT, submitBugReport),
    takeEvery(Types.UPDATE_BUG_REPORT, updateBugReport),
  ]);
}



// WEBPACK FOOTER //
// ./src/redux/sagas/bugReportFlow.js